import { render } from "./LeadershipView.vue?vue&type=template&id=a85babb2&scoped=true"
import script from "./LeadershipView.vue?vue&type=script&lang=js"
export * from "./LeadershipView.vue?vue&type=script&lang=js"

import "./LeadershipView.vue?vue&type=style&index=0&id=a85babb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85babb2"]])

export default __exports__